module.exports = __webpack_public_path__ + "static/media/main-classes-img1.fb0b4c81.svg";